import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const suggestBlog = (params) => {
  return Api(endPoints.suggestBlog, params, requestType.POST);
};

const createBlog = (params) => {
  return Api(endPoints.createBlog, params, requestType.POST);
};

const getAllBlogs = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search) queryParams.append("search", params.search);

  const finalUrl = queryParams.toString()
    ? `${endPoints.getAllBlogs}?${queryParams.toString()}`
    : endPoints.getAllBlogs;

  return Api(finalUrl, null, requestType.GET);
};

const getBlogDetail = (id) => {
  return Api(`${endPoints.getBlogDetail}/${id}`, {}, requestType.GET);
};

const updateBlog = (id, params) => {
  return Api(`${endPoints.updateBlog}/${id}`, params, requestType.PUT);
};

const deleteBlog = (id) => {
  return Api(`${endPoints.deleteBlog}/${id}`, {}, requestType.DELETE);
};

const getAllBlogSubscribers = (params = {}) => {

  const endPoint = ENDPOINTS.BLOG_SUBSCRIBER.GET_ALL;

  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search) queryParams.append("search", params.search);

  const finalUrl = queryParams.toString()
    ? `${endPoint}?${queryParams.toString()}`
    : endPoint;

  return Api(finalUrl, {}, requestType.GET);
};

export {
  suggestBlog,
  createBlog,
  getAllBlogs,
  getBlogDetail,
  updateBlog,
  deleteBlog,
  getAllBlogSubscribers,
};
